import { useState } from "react";
import { fieldNames } from "../../components/IBservicechange/steps/step3/utils";

export const {
  DIRECTOR_FULL_NAME,
  COUNTRY,
  IDENTIFICATION_NUMBER,
  CITY,
  COUNTRY_CODE,
  LEGAL_FORM,
  CITY_VILLAGE,
  APARTMENT_NUMBER,
  HOME_NUMBER,
  STREET,
  ACTUAL_ADDRESS,
  VILLAGE,
  NAME_OF_COMPANY,
  CONTACT_INFO_CHANGE_CHECKBOXES,
  DATA_UPDATE_CHANGES,
  ONE_TIME_CODE,
  DEVICE_CONFIRMATION,
  IB_CHANNEL,
  CODE_QUESTION,
  CODE_ANSWER,
  CHANGE_PHONE_SMS,
  ADD_PHONE_SMS,
  CHANGE_AUTH_NUMBER,
  ADD_AUTH_NUMBER,
  CONFIRMATION_STATUS,
  LEGAL_ADDRESS,
  MOBILE_NUMBER_CHANGE,
  EMAIL_CHANGE
} = fieldNames;

const initAddress = {
  [COUNTRY]: "",
  [CITY]: "",
  [STREET]: "",
  [CITY_VILLAGE]: "",
  [HOME_NUMBER]: "",
  [APARTMENT_NUMBER]: "",
  [VILLAGE]: "",
};

const initState = {
  [DIRECTOR_FULL_NAME]: "",
  [LEGAL_FORM]: "2",
  [IDENTIFICATION_NUMBER]: "",
  [COUNTRY_CODE]: "",
  [NAME_OF_COMPANY]: "",
  [CONTACT_INFO_CHANGE_CHECKBOXES]: [],
  [DATA_UPDATE_CHANGES]:[],
  [DEVICE_CONFIRMATION]:"",
  [IB_CHANNEL]:[],
  [ONE_TIME_CODE]:'',
  [CHANGE_PHONE_SMS]:"",
  [ADD_PHONE_SMS]:"",
  [CHANGE_AUTH_NUMBER]:"",
  [ADD_AUTH_NUMBER]:"",
  [CODE_QUESTION]:"",
  [CODE_ANSWER]:"",
  [CONFIRMATION_STATUS]: false,
  [ACTUAL_ADDRESS]: { ...initAddress },
  [LEGAL_ADDRESS]: { ...initAddress },
  [MOBILE_NUMBER_CHANGE]:"",
  [EMAIL_CHANGE]:"",
};

function useStepThreeValues() {
  const [stepThreeValues, setStepThreeValues] = useState(initState);
  return { stepThreeValues, setStepThreeValues };
}

export default useStepThreeValues;
